import { RadioGroup as CompassRadioGroup } from "@circleco/compass/components/RadioGroup";
import { useIsMobile } from "@circleco/compass/hooks/useIsMobile";
import { Controller, useFormContext } from "react-hook-form";

import { t } from "@/i18n-js/instance";

import { getVisibilityOptions } from "../../constants";
import type { SelectableVisibility, SpaceFormValues } from "../../types";
import { isSelectableVisibility } from "../../utils/visibility";
import { VisibilitySummary } from "./VisibilitySummary";

export const VisibilityField = () => {
  const { control } = useFormContext<SpaceFormValues>();
  const isMobile = useIsMobile();
  return (
    <Controller
      control={control}
      name="visibility"
      rules={{
        required: t("spaces.form.create.v4.errors.visibility_required"),
      }}
      render={({ field: { value, onChange } }) => {
        const selected: SelectableVisibility = isSelectableVisibility(value)
          ? value
          : "open";
        return (
          <div className="flex flex-col">
            <CompassRadioGroup
              legend={t("spaces.form.create.visibility_types.label")}
              legendProps={{ className: "sr-only" }}
              name="visibility"
              variant="option-cards"
              optionCardLayout="horizontal"
              optionCardColumns={isMobile ? 2 : 3}
              value={selected}
              onValueChange={next => onChange(next as SelectableVisibility)}
              options={getVisibilityOptions()}
            />
            <VisibilitySummary value={selected} />
          </div>
        );
      }}
    />
  );
};
